export default __webpack_public_path__ + "static/media/reg-input-gb.d4893c61.svg";